import { render } from "./pop-up.vue?vue&type=template&id=a6094662&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"

import "./pop-up.vue?vue&type=style&index=0&id=a6094662&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a6094662"

export default script